/* CUSTOM_BLOGBOT_BY_CLAUDE — hydrate interactive product hotspots.
 * Looks for .bb-hs markers (data-x,data-y in %, data-title, data-price, data-url,
 * data-thumb) inside a .bb-hsimg wrapper, builds the ring/line/card widget, and
 * chooses the line/card direction from the marker position — flipping it if the
 * card would overflow the image (edge-clamp). Styling lives in bb-hotspot.css. */
(function () {
  var CARD_W = Math.min(280, (window.innerWidth || 360) * 0.78);
  var CARD_H = 150; // approx card height for the vertical edge-clamp
  var OFFSET = 74;  // line length + gap before the card

  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  // ── Crosshair spin (JS-driven via Web Animations) ──────────────────────────
  // The "X" spins while a hotspot is hovered/open, then DECELERATES to a stop on
  // the original orientation when you leave or close it — instead of snapping
  // back (CSS animation removal) or staying stuck on a sticky touch :hover.
  var SPIN_MS = 3000; // slow, steady rotation
  var prefersReduced = false;
  try { prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var spins = (typeof WeakMap !== 'undefined') ? new WeakMap() : null;
  function startSpin(dot) {
    if (prefersReduced || !dot || !dot.animate || !spins) return;
    var s = spins.get(dot);
    if (s && s.mode === 'spin') return;            // already spinning
    if (s && s.anim) { try { s.anim.cancel(); } catch (e) {} } // cancel a decel in progress
    var anim = dot.animate(
      [{ transform: 'translate(-50%,-50%) rotate(0deg)' }, { transform: 'translate(-50%,-50%) rotate(360deg)' }],
      { duration: SPIN_MS, iterations: Infinity, easing: 'linear' }
    );
    spins.set(dot, { anim: anim, mode: 'spin' });
  }
  function stopSpin(dot) {
    if (!dot || !spins) return;
    var s = spins.get(dot);
    if (!s || s.mode !== 'spin') return;           // not spinning (or already decelerating)
    var anim = s.anim, cur = 0;
    try { cur = ((anim.currentTime || 0) % SPIN_MS) / SPIN_MS * 360; } catch (e) {}
    try { anim.cancel(); } catch (e) {}
    var target = Math.ceil(cur / 360) * 360;        // continue FORWARD to the next full turn (= original look)
    if (target - cur < 200) target += 360;          // guarantee enough travel for a visible wind-down
    var dec = dot.animate(
      [{ transform: 'translate(-50%,-50%) rotate(' + cur + 'deg)' }, { transform: 'translate(-50%,-50%) rotate(' + target + 'deg)' }],
      { duration: 1100, easing: 'cubic-bezier(0.2,0.8,0.25,1)', fill: 'none' } // ease-out → momentum stop
    );
    spins.set(dot, { anim: dec, mode: 'decel' });
    dec.onfinish = function () { var cs = spins.get(dot); if (cs && cs.anim === dec) spins.delete(dot); };
  }
  function stopSpinIn(node) { var d = node && node.querySelector ? node.querySelector('.bb-hs__dot') : null; if (d) stopSpin(d); }

  function hydrate(hs) {
    if (hs.getAttribute('data-bbhs-ready')) return;
    var wrap = hs.closest('.bb-hsimg');
    if (!wrap) return;
    hs.setAttribute('data-bbhs-ready', '1');

    var x = parseFloat(hs.getAttribute('data-x')); // %
    var y = parseFloat(hs.getAttribute('data-y')); // %
    if (isNaN(x) || isNaN(y)) return;
    hs.style.left = x + '%';
    hs.style.top = y + '%';

    // Direction: toward the side with more room, flipped if the card would overflow.
    var w = wrap.clientWidth || 780, h = wrap.clientHeight || 440;
    var px = x / 100 * w, py = y / 100 * h;
    var side = x < 50 ? 'right' : 'left';
    if (side === 'right' && px + OFFSET + CARD_W > w && px - OFFSET - CARD_W > 0) side = 'left';
    else if (side === 'left' && px - OFFSET - CARD_W < 0 && px + OFFSET + CARD_W < w) side = 'right';
    var vdir = y < 50 ? 'down' : 'up';
    if (vdir === 'down' && py + CARD_H > h && py - CARD_H > 0) vdir = 'up';
    else if (vdir === 'up' && py - CARD_H < 0 && py + CARD_H < h) vdir = 'down';
    hs.classList.add('dir-' + side, 'v-' + vdir);

    // Trim anything from " - " onward (drops dimension/variant tails, e.g.
    // 'Vyper 3 Vibrating Roller by Hyperice - 5.4" x 5.4"...' -> 'Vyper 3 Vibrating Roller by Hyperice')
    var title = (hs.getAttribute('data-title') || 'View product').split(' - ')[0].trim();
    var price = hs.getAttribute('data-price') || '';
    var url = hs.getAttribute('data-url') || '#';
    var thumb = hs.getAttribute('data-thumb') || '';

    hs.appendChild(el('div', 'bb-hs__bridge'));
    var hit = el('div', 'bb-hs__hit'); hs.appendChild(hit);
    var leader = el('div', 'bb-hs__leader'); leader.appendChild(el('span', 'bb-hs__end')); hs.appendChild(leader);
    hs.appendChild(el('div', 'bb-hs__ring'));
    var dotEl = el('div', 'bb-hs__dot'); hs.appendChild(dotEl);
    // Desktop: spin while hovered (mouseenter/leave fire for the whole hotspot,
    // including its card), decelerate to a stop on leave.
    hs.addEventListener('mouseenter', function () { startSpin(dotEl); });
    hs.addEventListener('mouseleave', function () { stopSpin(dotEl); });

    var card = el('div', 'bb-hs__card');
    var t = el('div', 'bb-hs__thumb'); // background-image div, not <img>, so theme img rules can't resize it
    if (thumb) { t.style.backgroundImage = "url('" + thumb.replace(/'/g, '%27') + "')"; t.setAttribute('role', 'img'); t.setAttribute('aria-label', title); }
    var info = el('div');
    var h4 = el('h4', 'bb-hs__title'); h4.textContent = title;
    var p = el('p', 'bb-hs__price'); p.innerHTML = price ? ('Starting at <b>' + price + '</b>') : '';
    var a = el('a', 'bb-hs__btn'); a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.innerHTML = '<span class="bb-hs__btnfill"></span><span class="bb-hs__btnt">View product →</span>';
    info.appendChild(h4); if (price) info.appendChild(p); info.appendChild(a);
    card.appendChild(t); card.appendChild(info);
    card.addEventListener('click', function (e) { e.stopPropagation(); }); // don't latch toggle when clicking the card/link
    a.addEventListener('click', function () { suppressOpen(); }); // close on navigate (sticky-hover guard)
    hs.appendChild(card);

    // Size the card to the room between its line-end and the image edge, so text
    // wraps before the card could ever run off the image. Floor keeps the
    // thumbnail + button readable; cap matches the design width.
    var avail = (side === 'right') ? (w - (px + OFFSET) - 8) : (px - OFFSET - 8);
    card.style.width = Math.max(150, Math.min(300, avail)) + 'px';

    // Open behavior is modality-aware (keyed off the pointer actually used, not
    // device capability — this machine is a touchscreen laptop, so capability
    // checks misfire):
    //  • MOUSE: the card already follows :hover (and the hover-bridge reaches it),
    //    so a click does NOT latch it open — it only stays out while hovered.
    //  • TOUCH/pen: no hover, so a tap toggles it open/closed (tapping elsewhere
    //    closes it). Spin starts on open and decelerates to a stop on the SAME tap
    //    that closes it (no lingering spin until a 2nd tap).
    var lastPT = '';
    hit.addEventListener('pointerup', function (e) { lastPT = e.pointerType || ''; });
    hit.addEventListener('click', function (e) {
      e.stopPropagation(); clearSuppress();
      var pt = (e.pointerType || lastPT);
      if (pt === 'mouse') return; // desktop hover drives it — don't latch on click
      if (hs.classList.toggle('is-open')) startSpin(dotEl); else stopSpin(dotEl);
    });
  }

  function closeAll(except) {
    document.querySelectorAll('.bb-hs.is-open').forEach(function (h) { if (h !== except) { h.classList.remove('is-open'); stopSpinIn(h); } });
  }

  // Sticky-hover guard: clicking the View product link opens a new tab, which can
  // leave the desktop :hover state "stuck on" so the card stays open when you
  // return. suppressOpen() force-closes every card (a class that overrides :hover);
  // the next real pointer move/down re-enables hover.
  var suppressActive = false;
  function suppressOpen() {
    suppressActive = true;
    document.querySelectorAll('.bb-hs').forEach(function (h) { h.classList.add('bb-hs--hoveroff'); h.classList.remove('is-open'); stopSpinIn(h); });
  }
  function clearSuppress() {
    if (!suppressActive) return;
    suppressActive = false;
    document.querySelectorAll('.bb-hs--hoveroff').forEach(function (h) { h.classList.remove('bb-hs--hoveroff'); });
  }

  // Inject the SVG displacement filter the liquid-glass card references via
  // backdrop-filter:url(#bbhs-liquid). Fractal noise → displacement map warps the
  // backdrop (the refraction). Chromium applies it; Safari/others ignore url() in
  // backdrop-filter and keep the plain frosted blur. Injected once.
  function injectFilter() {
    if (document.getElementById('bbhs-liquid')) return;
    var d = document.createElement('div');
    d.setAttribute('aria-hidden', 'true');
    d.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    // Large, smooth organic noise (low baseFrequency) → clean refraction, not busy.
    // STATIC (no <animate>): like real glass, the distortion holds still when the
    // card is still, and naturally shifts only while the card animates open (the
    // backdrop region behind it changes per frame). scale = warp strength.
    d.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">' +
      '<filter id="bbhs-liquid" x="-35%" y="-35%" width="170%" height="170%" color-interpolation-filters="sRGB">' +
      '<feTurbulence type="fractalNoise" baseFrequency="0.005 0.007" numOctaves="2" seed="7" result="n"/>' +
      '<feGaussianBlur in="n" stdDeviation="2.4" result="nb"/>' +
      '<feDisplacementMap in="SourceGraphic" in2="nb" scale="46" xChannelSelector="R" yChannelSelector="G"/>' +
      '</filter></svg>';
    document.body.appendChild(d);
  }

  function init() {
    injectFilter();
    document.querySelectorAll('.bb-hsimg .bb-hs').forEach(hydrate);
  }

  // 50ms haptic feedback on key blog interactions (Android; iOS Safari ignores
  // navigator.vibrate). Capture phase so it fires even when an inner handler
  // stopPropagations (hotspot tap, FAQ toggle). Covers TOC links, hotspot circles
  // (banner + in-blog), and FAQ questions.
  function buzz() { try { if (navigator.vibrate) navigator.vibrate(50); } catch (e) {} }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.bb-hs__hit, .table-of-contents a, .faq-question')) buzz();
  }, true);

  document.addEventListener('click', function () { closeAll(null); });
  // Re-enable hover on the next genuine pointer activity; also catch tab switches.
  document.addEventListener('pointermove', clearSuppress, true);
  document.addEventListener('pointerdown', clearSuppress, true);
  document.addEventListener('visibilitychange', function () { if (document.hidden) suppressOpen(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-hydrate if content is injected later.
  window.BBHotspots = { init: init };
})();
